import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eInventoryRouteNames } from '../enums/route-names';

export const ASSET_STATUSES_ASSET_STATUS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inventory/asset-statuses',
        parentName: eInventoryRouteNames.Inventory,
        name: 'Inventory::Menu:AssetStatuses',
        layout: eLayoutType.application,
        requiredPolicy: 'Inventory.AssetStatuses',
      },
    ]);
  };
}
